import { SVGProps } from "react"
const Phone4RentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.4311 13.062C9.28272 14.7281 10.7048 16.0718 12.4656 16.8743C12.5955 16.9326 12.7392 16.9578 12.8825 16.9475C13.0258 16.9372 13.1638 16.8917 13.2829 16.8155L15.8691 15.1789C15.9834 15.1054 16.1154 15.0606 16.2529 15.0486C16.3904 15.0367 16.5288 15.0578 16.6553 15.1103L21.4968 17.0802C21.6622 17.1454 21.8005 17.2604 21.8902 17.4074C21.9799 17.5543 22.0162 17.7252 21.9933 17.8936C21.8399 19.0282 21.2553 20.071 20.3489 20.8269C19.4426 21.5827 18.2766 21.9997 17.0691 22C13.3378 22 9.75923 20.5957 7.12076 18.0961C4.48228 15.5965 3 12.2063 3 8.67134C3.00027 7.52743 3.4405 6.4228 4.23832 5.56415C5.03613 4.70551 6.13686 4.15168 7.33454 4.00631C7.5123 3.98468 7.69265 4.01901 7.8478 4.10401C8.00295 4.18901 8.1243 4.31998 8.19317 4.47673L10.2725 9.07316C10.3266 9.19111 10.3492 9.31984 10.3384 9.44802C10.3275 9.5762 10.2836 9.6999 10.2104 9.8082L8.48283 12.2975C8.40591 12.4101 8.36077 12.5395 8.35171 12.6733C8.34266 12.8072 8.36999 12.941 8.4311 13.062V13.062Z"
      stroke={props.color || "#FFFFFF"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Phone4RentIcon
